var _path;

var _excluded = ["title", "titleId"];

function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) { ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } } return n; }, _extends.apply(null, arguments); }

function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) { o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } } return i; }

function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) { if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } } return t; }

import * as React from "react";

function SvgReports(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.5 3C5.5335 3 4.75 3.7835 4.75 4.75V15.25C4.75 16.2165 5.5335 17 6.5 17H13.5C14.4665 17 15.25 16.2165 15.25 15.25V7.73744C15.25 7.27331 15.0656 6.82819 14.7374 6.5L11.75 3.51256C11.4218 3.18437 10.9767 3 10.5126 3H6.5ZM8.25 11.75C8.25 11.2668 7.85825 10.875 7.375 10.875C6.89175 10.875 6.5 11.2668 6.5 11.75V14.375C6.5 14.8582 6.89175 15.25 7.375 15.25C7.85825 15.25 8.25 14.8582 8.25 14.375V11.75ZM10 9.125C10.4832 9.125 10.875 9.51675 10.875 10V14.375C10.875 14.8582 10.4832 15.25 10 15.25C9.51675 15.25 9.125 14.8582 9.125 14.375V10C9.125 9.51675 9.51675 9.125 10 9.125ZM13.5 8.25C13.5 7.76675 13.1082 7.375 12.625 7.375C12.1418 7.375 11.75 7.76675 11.75 8.25V14.375C11.75 14.8582 12.1418 15.25 12.625 15.25C13.1082 15.25 13.5 14.8582 13.5 14.375V8.25Z",
    fill: "#525252"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgReports);
export default __webpack_public_path__ + "static/media/reports.623694180edd479c0e75efb766d1a656.svg";
export { ForwardRef as ReactComponent };